export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["RESERVED"] = "reserved";
    OrderStatus["PAYMENT_PENDING"] = "payment_pending";
    OrderStatus["PAID"] = "paid";
    OrderStatus["COMPLETED"] = "completed";
    OrderStatus["CANCELLED"] = "cancelled";
    OrderStatus["NO_SHOW"] = "no_show";
})(OrderStatus || (OrderStatus = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["GCASH"] = "gcash";
    PaymentMethod["MAYA"] = "maya";
    PaymentMethod["CARD"] = "card";
})(PaymentMethod || (PaymentMethod = {}));
